export enum DATA_SOURCE_TAB_CATEGORY {
  CONTACTS = 'contacts',
  PORTFOLIOS = 'portfolios',
}
